import React from "react";
import { ArrowBack } from "@mui/icons-material";
import {
  HeaderContainer,
  HeaderContent,
  TitleContainer,
  Title,
  Description,
} from "./Header.styled";

const Header = ({ 
  title, 
  description, 
  onBack,
  textAlign = 'left',
  headerSize
}) => {
  return (
    <HeaderContainer>
      <HeaderContent textAlign={textAlign} data-testid="header-content">
        <TitleContainer textAlign={textAlign}>
          {onBack && (
            <ArrowBack
              style={{
                width: "16px",
                height: "16px",
                flexShrink: 0,
                cursor: "pointer",
                marginRight: "8px",
              }}
              onClick={onBack}
            />
          )}
          <Title headerSize={headerSize}>{title}</Title>
        </TitleContainer>
        <Description>{description}</Description>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header; 